import {Component, OnInit} from '@angular/core';
import {TimelineProvider} from './timeline.provider';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {


    loading: boolean;
    constructor(private provider: TimelineProvider) {}

    ngOnInit() {
        this.loading = true;
        this.loading = false;
    }

}
